import {
	useRouter,
	matchRoute,
	type RouterContext,
	type RouterDataContext,
	type Query,
} from '@atlassian/jira-router';
import { filtersDirectoryRoute } from '@atlassian/jira-router-routes-directories-routes';
import {
	globalIssueNavigatorRoute,
	globalIssueNavigatorBrowseIssueRedirectRoute,
} from '@atlassian/jira-router-routes-issue-navigator-routes';

export function useIsFiltersUrl() {
	const [{ match, query }] = useRouter();

	return isFiltersUrl(match.path, query);
}

export function isFiltersRoute(routerContext: RouterContext | RouterDataContext) {
	const { match, query } = routerContext;

	return isFiltersUrl(match.path, query);
}

const filterRoutes = [
	globalIssueNavigatorRoute,
	globalIssueNavigatorBrowseIssueRedirectRoute,
	filtersDirectoryRoute,
];
function isFiltersUrl(path: string, query: Query) {
	return matchRoute(filterRoutes, path, query) !== null;
}
